import { jsx as s, jsxs as g, Fragment as k } from "react/jsx-runtime";
import { useState as x, useCallback as S } from "react";
import { EyeFillIcon as v, EyeOffLineIcon as O } from "@ifrc-go/icons";
import j from "../InputContainer/index.js";
import B from "../RawInput/index.js";
import E from "../../hooks/useTranslation.js";
import F from "../Button/index.js";
const T = "common", q = {
  hidePassword: "Hide password",
  showPassword: "Show password"
}, A = {
  namespace: T,
  strings: q
};
function K(n) {
  const {
    actions: e,
    className: i,
    disabled: o,
    error: l,
    errorOnTooltip: m,
    hint: c,
    icons: p,
    inputClassName: d,
    inputSectionClassName: w,
    labelClassName: u,
    label: f,
    readOnly: r,
    required: h,
    variant: P,
    withAsterisk: C,
    ...I
  } = n, [t, y] = x(!1), a = E(A), N = S(() => {
    y((b) => !b);
  }, []);
  return /* @__PURE__ */ s(
    j,
    {
      className: i,
      disabled: o,
      error: l,
      errorOnTooltip: m,
      hint: c,
      icons: p,
      inputSectionClassName: w,
      labelClassName: u,
      label: f,
      readOnly: r,
      required: h,
      variant: P,
      withAsterisk: C,
      actions: /* @__PURE__ */ g(k, { children: [
        e,
        /* @__PURE__ */ s(
          F,
          {
            onClick: N,
            variant: "tertiary",
            disabled: o,
            name: void 0,
            title: t ? a.hidePassword : a.showPassword,
            children: t ? /* @__PURE__ */ s(v, {}) : /* @__PURE__ */ s(O, {})
          }
        )
      ] }),
      input: /* @__PURE__ */ s(
        B,
        {
          ...I,
          className: d,
          readOnly: r,
          disabled: o,
          type: t ? "text" : "password"
        }
      )
    }
  );
}
export {
  K as default
};
